import { Component, Input, OnChanges, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
/**
 * Service imports
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { PostApiService } from '../../dataservices/post-api.service';

/**
  * Rxjs imports.
  */
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * Import Language Service
 */
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
/**
 * Constant imports.
 */
import { GRADIENT_DIRECTION, NUMBERS, PRODUCT_TYPE_CONSTANT, PROTOCOL, SCREEN_NAME, SPLIT } from '../../constants/app.constants';
import { ActivatedRoute } from '@angular/router';
import { DataStorageService } from 'src/app/dataservices/data-storage.service';
import { FileUploadKeeperService } from 'src/app/dataservices/file-upload-keeper.service';
@Component({
  selector: 'app-community-posts-filter-feed',
  templateUrl: './community-posts-filter-feed.component.html',
  styleUrls: ['./community-posts-filter-feed.component.scss']
})
export class CommunityPostsFilterFeedComponent implements OnInit, OnChanges, OnDestroy {
  /**
   * Input Variable to get Post Data by Filter
   */
  @Input() postDataByFilter;
  @Input() postOffSet;
  @Input() postDataLoader: boolean;
  /**
   * whether community Admin
   */
  @Input() isCommunityAdmin = false;

  /**
   * Output variable to pass offset while scroll
   * Output reload feed event after feed is deleted
   */
  @Output() setPostDataOffset = new EventEmitter();
  @Output() emitReloadFeed = new EventEmitter();
  /**
   * @finished Variable to set Loaders State
   * @numberZero for Zero
   * @numbers for Number constant
   * @productType for product type constant
   */
  public finished = false;
  public numberZero = NUMBERS.ZERO;
  public numbers = NUMBERS;
  public productType = PRODUCT_TYPE_CONSTANT;
  /**
   * Screen name.
   */
  public callingFrom = SCREEN_NAME.COMMUNITY_DETAILS;
  /**
    * To unsubscribe data.
    */
  private subscriptions: Subscription = new Subscription();
  /**
   * @notifier$ subject to destory streams
   * @communityId for communityId
   */
  private notifier$ = new Subject();
  private communityId: string;

  /**
   * Gradient direction constant
   */
  public gradientDirection = GRADIENT_DIRECTION;

  /**
   * Spilt symbol for the product type and id.
   */
  private splitProductTypeId = SPLIT;

  /**
   * Key used to store selected specialty name.
   */
  public selectedSpecialty: string;

  /**
   * Get all the file urls with file code.
   */
  public fileSignedUrls: { [code: string]: any } = [];
  /**
   * local offset value to avoid multiple API calling
   */
  private lastOffset: number = this.numbers.ZERO;

  public busyGettingData = false;

  constructor(public mls: NewLanguageService,
              private postSer: PostApiService,
              private fcs: FunCollectionService,
              private dss: DataStorageService,
              private fileUploadService: FileUploadKeeperService,
              private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.paramMap.
      pipe(takeUntil(this.notifier$))
      .subscribe((params) => {
        this.communityId = params.get('communityId');
      });
  }

  ngOnChanges(): void {
    this.finished = true;
    
    this.busyGettingData = false;

    if (this.postDataLoader) {
      this.finished = false;
    }

    this.getImagesFromKeeper(this.postDataByFilter);
  }
  /**
   * function to check the incomming offest value and the present offest value
   * @returns 
   */
  public onScrollDown():void {
    if(this.busyGettingData){
      return;
    }
    this.busyGettingData = true;
    this.onScroll();
  }

  /**
   * On Scroll
  */
  onScroll(): void {
    if (this.postOffSet > NUMBERS.ONE) {
      this.setOffset();
    }
  }

  /**
   * Set Off set
  */
  setOffset(): void {
    this.setPostDataOffset.emit(this.postOffSet);
    this.finished = true;
    if (this.postDataByFilter) {
      this.finished = false;
    }
  }

  /**
   * delete Feed Idx
  */
  deleteFeedIdx(feed_idx): void {
    this.subscriptions.add(this.postSer.deleteFeed(this.postDataByFilter[feed_idx].products[0].feed_id).subscribe(resData => {
      if (resData['status'] === NUMBERS.ONE) {
        if (this.postDataByFilter.length === NUMBERS.ONE) {
          this.postDataByFilter = [];
        }
        this.fcs.showSuccess(resData['msg'], 'Success');
        this.setPostDataOffset.emit(NUMBERS.ONE);
      }
      if (resData['status'] === NUMBERS.ZERO) {
        this.fcs.errorHandeler(resData);
      }
    }));
  }

  /**
   * Event handler to trigger delete feed in community by admin of the community
   * @param feedIndex for delete community feed
   * @returns as per use case
   */
  deleteCommunityFeed(feedObj): void {
    if (feedObj.idx < NUMBERS.ZERO || !this.communityId) {
      return;
    }
    this.postSer.deleteCommunityPost({
      communityId: this.communityId,
      productType: this.postDataByFilter[feedObj.idx].product_type,
      postId: feedObj.id
    }).pipe(
      takeUntil(this.notifier$)
    ).subscribe(response => {
      if (response.status === NUMBERS.ONE) {
        this.fcs.showSuccess(this.mls.languageText.toster.key2, this.mls.languageText.toster.key2);
        //admin deleted community feed
        //this.emitReloadFeed.emit(true);
        this.setPostDataOffset.emit(NUMBERS.ONE);
      } else {
        this.fcs.errorHandeler(response);
      }
    }, error => {
      this.fcs.errorHandeler(error);
    });
  }

  /**
   * Get the appeared card product type and id.
   */
    getAppearedIds(card): string {
      if (card.product_type === PRODUCT_TYPE_CONSTANT.EDITORS_CHOICE) {
        return `${card.product_type}${this.splitProductTypeId}${card.products[0].product_type_id}`;
      }
      return `${card.product_type}${this.splitProductTypeId}${card.product_type_id ? card.product_type_id : card.product_id}`;
    }

      /**
   * Feed specialty from feed post card.
   */
  feedListFilteredBySpecialty(specialty): void {
    this.selectedSpecialty =
      specialty.speciality_name || specialty.category_name;
    const specialtyVal =
      [{
        key: 'speciality',
        value: [specialty.speciality_id || specialty.category_id]
      }];
    this.dss.feed_filter.next(specialtyVal);
  }

  changeSurveyType(data?): void {
    
  }

  /**
   * Collects all the appeared cards on the DOM view.
   */
    onCardAppear(cards): void {
    }

  /**
   * Get the url from file code.
   */
  getImagesFromKeeper(data): void {
    const fileCode = [];
 
    for (const file of data) {
      if(file?.product_type ==  this.productType?.SURVEY){
        if (file?.products[0]?.bcode) {
          fileCode.push(file?.products[0].bcode);
          console.log(fileCode)
        }
      }
    }
    if (fileCode?.length) {
      this.fileUploadService.readMultipleFiles(fileCode, 'DQ')
        .then(value => {
          if (value?.preSignedUrl) {
            for (const code of Object.keys(value.preSignedUrl)) {
              this.fileSignedUrls[code] = value.preSignedUrl[code];
            }
          }
        })
        .catch(reason => {
          console.log('reason', reason);
        });
    }
  }
    

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.notifier$.next();
    this.notifier$.complete();
  }

}
